import AppContext from "@/AppContext";
import DummyLogo from "@/assets/images/lucidity-placeholder.png";
import { loginPopup, claimVCPopup, userAtom } from "@/Atoms";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import formatNumber from "@/utils/formatNumber";
import getCoverageStages from "@/utils/getCoverageStages";
import getIcon from "@/utils/getIcon";
import { fitIn } from "@/utils/imageHandler";
import { Heart, MapPin, Plus } from "@phosphor-icons/react";
import { useAtom } from "jotai";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { Badge } from "../ui/badge";
import WishlistAddNew from "../WishlistAddNew";
import { Button } from "../ui/button";
import { ClaimInvestor } from "./claim-investor";
import {
  getAllAccessByVcId,
  getVCPageByVCId,
} from "@/services/api/VentureCapital";
import toast from "react-hot-toast";
import { CheckCircle } from "@phosphor-icons/react/dist/ssr";
import { requestEditAccess } from "@/services/api/RequestEditVC";
import InActiveIcon from "@/assets/images/inactive.png";
import { ClaimAngel } from "./claim-angel";
import ClaimModalPay from "../ClaimModalPay";
import InfoModal from "../InfoModal";
import { getAvatarByIdOrDefault } from "@/utils/avatarOptions";
const InvestorCard = ({
  user,
  investor,
  locked,
  claimable,
  newTab = false,
  // getWishlistCategories,
  // wishlistCategories,
  // setWishlistCategories,
  // getUserWishlist,
  // userWishlist,
}) => {
  const router = useRouter();
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [openWishlistAction, setOpenWishlistAction] = useState(false);
  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);
  const [userClaimData, setUserClaimData] = useState(null);
  const [openClaimVCPopup, setOpenClaimVCPopup] = useAtom(claimVCPopup);
  const [userState, setUserState] = useAtom(userAtom);
  const [isLoadingRequestAccess, setIsLoadingRequestAccess] = useState(false);
  const {
    userVCWishlistIds,
    onRemoveVCWishlist,
    getWishlistCategories,
    wishlistCategories,
    setWishlist,
    addWishlistCategory,
    state,
  } = useContext(AppContext);

  const [
    openPurchaseClaimAngelInvestorPopup,
    setOpenPurchaseClaimAngelInvestorPopup,
  ] = useState(false);

  const { planSubscription } = state;

  const hasSubscription =
    planSubscription && planSubscription.has_active_subscription;

  const [showAlreadyClaimedModal, setShowAlreadyClaimedModal] = useState(false);

  // Function to handle My Wishlist click without propagating
  const handleMyWishlistClick = (event, cat_id, investor_id) => {
    event.stopPropagation();
    setWishlist(cat_id, investor_id, 2);
    // Add navigation or any other logic for My Wishlist here
  };

  const handleChange = (e) => {
    if (!userState) {
      return setOpenLoginPopup(true);
    }
    getWishlistCategories();
    setOpenWishlistAction(e);
  };

  const getVCClaimUserData = async () => {
    setUserClaimData(null);
    const response = await getVCPageByVCId(investor.id, {
      params: {
        status: "pending",
      },
    });

    if (response.data) {
      setUserClaimData(response.data);
    }
  };

  const requestAccess = async (investor) => {
    try {
      let vcEditAccess = null;
      let vcOwnerData = null;
      const res = await getAllAccessByVcId(investor.id, {
        params: {
          is_angel: investor.is_angel ? "true" : "false",
        },
      });
      if (res.data && res.data.data?.approved_members) {
        vcEditAccess = res.data.data.approved_members;
        vcOwnerData = res.data.data.owner;
      }

      // check is userState email base domain same with vcOwnerData email base domain
      if (
        investor.is_angel ||
        (vcOwnerData &&
          userState &&
          userState.email.split("@")[1] === vcOwnerData.email.split("@")[1])
      ) {
        try {
          setIsLoadingRequestAccess(true);
          const response = await requestEditAccess({
            vc_id: investor.id,
          });
          if (response.data.success) {
            toast.success("Access requested successfully");
          } else {
            toast.error(
              "Sorry you cant access this profile, your email is not eligible for this profile"
            );
          }
        } catch (error) {
          console.error("Error requesting access:", error);
          toast.error("Error requesting access");
        } finally {
          setIsLoadingRequestAccess(false);
        }
      } else {
        toast.error(
          "Sorry you cant access this profile, your email is not eligible for this profile"
        );
      }
    } catch (error) {
      console.error("Error fetching VC edit access:", error);
    }
  };

  function CardContent() {
    return (
      <div
        className={`relative flex flex-col justify-between h-full overflow-hidden text-sm transition-colors duration-200 rounded-lg lg:p-5 lg:py-4 lg:bg-white/5 ${
          !locked &&
          router.pathname !== "/investors/claim" &&
          router.pathname !== "/angel-investors/register" &&
          "hover:bg-white/10"
        }`}
      >
        {locked && (
          <span className='absolute inset-0 z-10 bg-background/60 backdrop-blur-sm'></span>
        )}
        {router.pathname !== "/investors/claim" &&
          router.pathname !== "/angel-investors/register" && (
            <span className='absolute inset-0 hidden overflow-hidden lg:block'>
              <span className='absolute top-0 right-0 z-0 w-36 h-36 group-hover:scale-[400%] origin-top-right transition-transform duration-500 translate-x-[60%] -translate-y-[60%] rounded-full bg-white/[0.02]'></span>
            </span>
          )}

        {userVCWishlistIds && (
          <div className='absolute flex items-center text-white gap-x-1 right-0 lg:right-1.5 top-0 lg:top-2'>
            {userVCWishlistIds.includes(investor.id) ? (
              <button
                type='button'
                onClick={(e) => onRemoveVCWishlist(e, investor.id)}
              >
                <Heart weight='fill' color='red' className='text-2xl' />
              </button>
            ) : (
              <DropdownMenu
                open={openWishlistAction}
                onOpenChange={handleChange}
              >
                <DropdownMenuTrigger asChild>
                  <button type='button'>
                    <Heart weight='bold' className='text-2xl' />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className='w-[200px] max-h-[300px] overflow-y-auto'>
                  <DropdownMenuLabel className='text-xs font-medium text-white/40'>
                    Add to Watchlist
                  </DropdownMenuLabel>
                  <DropdownMenuItem
                    onClick={(event) => {
                      event.stopPropagation(); // Prevent click event from bubbling up
                      setIsAddDialogOpen(true); // Open the add dialog
                      setOpenWishlistAction(false);
                    }}
                  >
                    <Plus weight='bold' className='mr-2' />
                    <span>Create New Watchlist</span>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem
                    onClick={(e) => handleMyWishlistClick(e, null, investor.id)}
                  >
                    My Watchlist
                  </DropdownMenuItem>
                  {hasSubscription &&
                    wishlistCategories?.map((cat) => (
                      <DropdownMenuItem
                        key={cat.id}
                        onClick={(e) =>
                          handleMyWishlistClick(e, cat.id, investor.id)
                        }
                      >
                        {cat.name}
                      </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
              </DropdownMenu>
            )}
          </div>
        )}
        <div className='relative'>
          <div className='flex items-start space-x-3'>
            <div
              className={`relative flex items-center justify-center flex-shrink-0 rounded-full  overflow-hidden bg-white aspect-square size-12 ${
                investor.is_angel ? "" : "lg:rounded-xl"
              }`}
            >
              <Image
                src={
                  investor.logo_url
                    ? fitIn(investor.logo_url, 400)
                    : investor.is_angel && investor.avatar
                    ? getAvatarByIdOrDefault(investor.avatar)
                    : DummyLogo
                }
                alt={investor?.name}
                layout='fill'
                objectFit='cover'
              />
            </div>
            <div className='flex-1 pr-10 lg:pr-0'>
              {!!investor.is_angel && (
                <div className='inline-flex py-1 px-2 leading-none text-[11px] text-black relative mb-2 bg-white rounded-full font-medium'>
                  Angel Investor
                </div>
              )}

              {!!investor.is_inactive && (
                <span className='mb-1.5 inline-flex items-center justify-center px-2 py-1 text-[8px] tracking-wide uppercase font-medium leading-none rounded-full bg-gradient-to-tr from-red-700 to-red-500'>
                  Inactive
                </span>
              )}

              <p className='text-base font-semibold leading-tight lg:text-lg'>
                {investor?.name}
              </p>

              {investor?.top_sectors?.length > 0 && (
                <p className='hidden lg:block text-[11px] leading-snug text-transparent bg-clip-text mt-1 mb-2 bg-gradient-to-tr lg:leading-normal from-yellow-1 to-red-1'>
                  {investor?.top_sectors?.length > 0
                    ? investor?.sectors
                        .filter((s) => investor?.top_sectors.includes(s.id))
                        .map((item) => item.name)
                        .join(", ")
                    : ""}
                </p>
              )}

              <div className='flex items-center gap-1 lg:block'>
                <span
                  className={`lg:hidden text-transparent bg-clip-text bg-gradient-to-tr inline-block lg:text-2xl tracking-tight text-base from-yellow-1 to-red-1 font-bold`}
                >
                  {investor?.number_assets_under_management
                    ? `$${formatNumber(
                        investor?.number_assets_under_management
                      )}`
                    : "-"}
                </span>

                {investor.city && investor.country && (
                  <>
                    <span className='lg:hidden opacity-40'>&bull;</span>
                    <p className='text-xs opacity-50 lg:mb-2'>
                      {investor.city?.name}, {investor.country?.country_name}
                    </p>
                  </>
                )}
              </div>

              {!claimable &&
                (router.pathname === "/investors/claim" ||
                  router.pathname === "/angel-investors/register") && (
                  <span className='inline-flex items-center gap-1 mt-1 text-xs font-medium text-green-500'>
                    <CheckCircle
                      weight='fill'
                      className='w-3.5 h-3.5 -translate-y-px'
                    />
                    Claimed
                  </span>
                )}
            </div>
          </div>
          <div className='hidden lg:flex items-center justify-between px-2 py-1.5 my-3.5 -mx-2 space-x-2 rounded-md bg-white/5'>
            <span className='flex items-center space-x-1 text-[11px] font-medium text-white'>
              <MapPin weight='duotone' className='text-base text-white/30' />
              <span className='text-white/60'>
                {investor?.city?.name} - {investor?.country?.country_name}
              </span>
            </span>
            <span className='px-2 py-1 leading-none text-[10px] rounded-full text-white/40 bg-white/10 font-medium'>
              Est.{" "}
              <span className='text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                {investor?.year_established}
              </span>
            </span>
          </div>
          <div className='hidden lg:flex'>
            <p className='flex-1 text-xs leading-relaxed text-white/50 line-clamp-3'>
              {investor?.summary}{" "}
            </p>
            <div className='flex flex-col items-end justify-center pl-3 ml-3 text-right border-l'>
              <span className='inline-block text-3xl font-semibold text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1 lg:text-2xl'>
                {investor?.number_assets_under_management
                  ? `$${formatNumber(investor?.number_assets_under_management)}`
                  : "-"}
              </span>
              <span className='text-[10px] opacity-60 font-medium'>AUM</span>
            </div>
          </div>
        </div>
        {investor?.coverage_stages?.length > 0 && (
          <div className='mt-1 ml-14 lg:ml-0 lg:mt-0'>
            <div className='hidden lg:flex items-center mt-3 mb-2.5 space-x-3'>
              <span className='flex-1 h-px bg-white/5'></span>
              <p className='text-[11px] opacity-30'>Invested investor Stages</p>
              <span className='flex-1 h-px bg-white/5'></span>
            </div>
            <div className='flex flex-wrap gap-1'>
              {getCoverageStages(investor?.coverage_stages).map((stage) => (
                <Badge
                  variant='outline'
                  className='text-[10px] h-auto text-white/60 font-normal leading-none px-2 py-1 bg-white/5'
                  key={`stage-${stage.type}`}
                >
                  <img
                    src={getIcon(stage.type)}
                    className='h-2 lg:h-3.5 mr-1'
                    alt='Stage Type'
                  />
                  {stage.name}
                </Badge>
              ))}
            </div>
          </div>
        )}
        {(router.pathname === "/investors/claim" ||
          router.pathname === "/angel-investors/register") && (
          <div className='relative flex gap-2 pt-4 mt-4 border-t border-dashed border-white/10'>
            <Link
              href={`${
                investor.is_angel
                  ? `/angel-investors/${investor.slug}-${investor.id}`
                  : `/investors/${investor.slug}-${investor.id}`
              }`}
              target='_blank'
              className='w-full h-auto px-4 py-2 text-sm text-center text-white bg-transparent border rounded-md border-white/10 hover:bg-white/5'
            >
              More Details
            </Link>
            {claimable ? (
              <Button
                onClick={() => {
                  if (!userState) {
                    return setOpenLoginPopup(true);
                  }

                  // For angel investors, check subscription before opening claim popup
                  if (
                    investor.is_angel &&
                    !planSubscription?.is_angel_investor_plan
                  ) {
                    setOpenPurchaseClaimAngelInvestorPopup(true);
                  } else {
                    if (investor.is_angel && planSubscription?.has_angel_vc) {
                      setShowAlreadyClaimedModal(true);
                    } else {
                      setOpenClaimVCPopup(investor.id);
                    }
                  }
                }}
                className='w-full h-auto px-4 py-2 text-sm'
              >
                Claim Profile
              </Button>
            ) : (
              <>
                {router.pathname !== "/angel-investors/register" && (
                  <Button
                    onClick={
                      userState
                        ? () => requestAccess(investor)
                        : () => setOpenLoginPopup(true)
                    }
                    className='w-full h-auto px-4 py-2 text-sm'
                    disabled={isLoadingRequestAccess}
                  >
                    {isLoadingRequestAccess ? "Loading..." : "Request Access"}
                  </Button>
                )}
              </>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {!locked &&
      router.pathname !== "/investors/claim" &&
      router.pathname !== "/angel-investors/register" ? (
        newTab ? (
          <a
            href={
              investor.is_angel
                ? `/angel-investors/${investor.slug}-${investor.id}`
                : `/investors/${investor.slug}-${investor.id}`
            }
            target='_blank'
            rel='noopener noreferrer'
            className={`block h-full text-left cursor-pointer ${!locked ? "group" : ""}`}
          >
            <CardContent />
          </a>
        ) : (
          <Link
            href={
              investor.is_angel
                ? `/angel-investors/${investor.slug}-${investor.id}`
                : `/investors/${investor.slug}-${investor.id}`
            }
            className={`block h-full text-left cursor-pointer ${!locked ? "group" : ""}`}
          >
            <CardContent />
          </Link>
        )
      ) : (
        <div className='block h-full text-left'>
          <CardContent />
        </div>
      )}

      {openClaimVCPopup === investor.id && (
        <>
          {investor.is_angel ? (
            <ClaimAngel
              getVCClaimUserData={getVCClaimUserData}
              user={userState}
              investor={investor}
              setOpenClaimVCPopup={setOpenClaimVCPopup}
              openClaimVCPopup={openClaimVCPopup}
            />
          ) : (
            <ClaimInvestor
              getVCClaimUserData={getVCClaimUserData}
              user={userState}
              investor={investor}
              setOpenClaimVCPopup={setOpenClaimVCPopup}
              openClaimVCPopup={openClaimVCPopup}
            />
          )}
        </>
      )}

      <WishlistAddNew
        id={investor.id}
        type={2}
        addWishlistCategory={addWishlistCategory}
        isOpen={isAddDialogOpen}
        setIsOpen={setIsAddDialogOpen}
        wishlistCategories={wishlistCategories}
        hasSubscription={hasSubscription}
      />
      {openPurchaseClaimAngelInvestorPopup && (
        <ClaimModalPay
          isOpen={openPurchaseClaimAngelInvestorPopup}
          onClose={() => setOpenPurchaseClaimAngelInvestorPopup(false)}
        />
      )}

      <InfoModal
        isOpen={showAlreadyClaimedModal}
        onClose={() => setShowAlreadyClaimedModal(false)}
        title='You already have an angel investor profile'
        description='Each user can only claim one angel investor profile.'
        variant='error'
      />
    </>
  );
};

export default InvestorCard;
